
import styles from '../ProductInfo.module.css';

interface PreviewBoxProps {
    text: string;
    fontFamily: string;
    style?: React.CSSProperties;
}

export const PreviewBox = ({ text, fontFamily, style }: PreviewBoxProps) => {
    // Split text around ♡ to render heart at a smaller size for visual harmony.
    const parts = text.split('♡');
    const hasHeart = parts.length > 1;

    return (
        <div className={styles.previewSection}>
            <h4 className={styles.customizationTitle}>Aperçu de la broderie demandée</h4>
            <div className={styles.previewBox}>
                <span className={styles.previewText} style={{ fontFamily: fontFamily, ...style }}>
                    {hasHeart
                        ? parts.map((part, i) => (
                            <span key={i}>
                                {part}
                                {i < parts.length - 1 && (
                                    <span style={{ fontSize: '20px', verticalAlign: 'middle' }}>♡</span>
                                )}
                            </span>
                        ))
                        : text
                    }
                </span>
            </div>
        </div>
    );
};
